module.exports = __webpack_public_path__ + "img/cobalt_master_bedroom.jpg";